import { createReducer } from '../../utilities';
import {
    FAIL_USERS_RETENTION,
    REQUEST_USERS_RETENTION,
    SUCCESS_USERS_RETENTION
} from "../../../actions/entities/dailyReport";

const initialState = {
    data: null,
    error: false,
    isFetching: false,
};

function requestFetch(state) {
    return {
        ...state,
        isFetching: true,
    };
}

function successFetch(state, action) {
    const { data } = action;
    return {
        ...state,
        data,
        isFetching: false,
    };
}

function failFetch(state, action) {
    const { error } = action;
    return {
        ...state,
        isFetching: false,
        error
    };
}

export default createReducer(initialState, {
    [REQUEST_USERS_RETENTION]: requestFetch,
    [SUCCESS_USERS_RETENTION]: successFetch,
    [FAIL_USERS_RETENTION]: failFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/usersRetention.js